module.exports = __webpack_public_path__ + "img/OOT.8cfd53a9.svg";